"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _botframeworkWebchatComponent = _interopRequireDefault(require("botframework-webchat-component"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _AdaptiveCardsComposer = _interopRequireDefault(require("./adaptiveCards/AdaptiveCardsComposer"));

var _useComposerProps = _interopRequireDefault(require("./useComposerProps"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
} // Add additional props to <WebChat>, so it support additional features


var FullReactWebChat = function FullReactWebChat(props) {
  var adaptiveCardHostConfig = props.adaptiveCardHostConfig,
      adaptiveCardsHostConfig = props.adaptiveCardsHostConfig,
      adaptiveCardsPackage = props.adaptiveCardsPackage,
      otherProps = (0, _objectWithoutProperties2.default)(props, ["adaptiveCardHostConfig", "adaptiveCardsHostConfig", "adaptiveCardsPackage"]);
  (0, _react.useEffect)(function () {
    adaptiveCardHostConfig && console.warn('Web Chat: "adaptiveCardHostConfig" is deprecated. Please use "adaptiveCardsHostConfig" instead. "adaptiveCardHostConfig" will be removed on or after 2022-01-01.');
  }, [adaptiveCardHostConfig]);
  var composerProps = (0, _useComposerProps.default)(props);
  return _react.default.createElement(_AdaptiveCardsComposer.default, {
    adaptiveCardsHostConfig: adaptiveCardHostConfig || adaptiveCardsHostConfig,
    adaptiveCardsPackage: adaptiveCardsPackage
  }, _react.default.createElement(_botframeworkWebchatComponent.default, (0, _extends2.default)({}, otherProps, composerProps)));
};

FullReactWebChat.defaultProps = _objectSpread({}, _botframeworkWebchatComponent.default.defaultProps, {
  adaptiveCardHostConfig: undefined,
  adaptiveCardsHostConfig: undefined,
  adaptiveCardsPackage: undefined,
  renderMarkdown: undefined
});
FullReactWebChat.propTypes = _objectSpread({}, _botframeworkWebchatComponent.default.propTypes, {
  adaptiveCardHostConfig: _propTypes.default.any,
  adaptiveCardsHostConfig: _propTypes.default.any,
  adaptiveCardsPackage: _propTypes.default.any,
  renderMarkdown: _propTypes.default.func
});
var _default = FullReactWebChat;
exports.default = _default;